import { handleSessionOut } from "../HelperFunctions/HelperFunctions";
import { getToken } from "./tokenStore";

const authApiUrl = process.env.REACT_APP_AUTH_API_URL;
const baseApi8Url = process.env.REACT_APP_BASE_API_8_URL;
const baseApi7Url = process.env.REACT_APP_BASE_API_7_URL;


async function validateToken() {
  const token = getToken();
  let res = await fetch(`${authApiUrl}/v1/OpenApiauth/ValidateToken`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ token }),
  });
  let data = await res.json();

  if (data.statusCode !== 200) {
    await handleSessionOut()
    return false;

  };

  return true;
}


export async function exchangeToken(url, authID) {
  let res = await fetch(`${authApiUrl}/${url}/OpenApiauth/ExchangeOAuth`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ token: authID }),
  });

  if (res.status === 200) {
    let data = await res.json();
    return data;
  }
  else if (res.status === 401) {

    await handleSessionOut()
    throw res
  }

  else throw res;
}


export async function refreshToken(token, url, refAuthID) {
  const res = await fetch(`${authApiUrl}/${url}/OpenApiauth/RefreshToken`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ refAuthID }),
  });

  const data = await res.json();

  // console.log("dataaaa", data.statusCode || data.StatusCode)

  // if (data?.token && data?.minutesToExpire && data?.refAuth && data.statusCode === 200) {
  if (data.statusCode === 200) {
    return {
      token: data.token,
      minutesToExpire: data.minutesToExpire,
      refAuthID: data.refAuth,
    };
  }
  await handleSessionOut()
  return null;
}


export async function getPrivileges(UID, menuID) {

  const isValidToken = await validateToken();
  if (!isValidToken) return null;

  const token = getToken();
  let res = await fetch(`${baseApi7Url}/Previlages`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      RoleID: "000000000000000000000000000000000000",
      UserID: UID,
      MenuIds: menuID,
    }),
  });

  let data = await res.json();
  let privilages = data["Details"];

  return privilages.length > 0 ? privilages[0] : {};
}


export async function getScheduleCategories() {

  const isValidToken = await validateToken();
  if (!isValidToken) return null;

  const token = getToken();

  let res = await fetch(`${baseApi7Url}/GetScheduledReportMenuInfo`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  return res.json();
}


export async function getSubUserListByUserId() {

  const isValidToken = await validateToken();
  if (!isValidToken) return null;

  const token = getToken();

  let res = await fetch(
    `${baseApi7Url}/GetSubUserListByUserId`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );

  let data = await res.json();
  return data["UserCorporations"];
}


export async function getManagementGroupsList() {

  const isValidToken = await validateToken();
  if (!isValidToken) return null;

  const token = getToken();

  let res = await fetch(`${baseApi7Url}/GetManagementGroupsList`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  // return res.json();
  return res;
}

export async function getCorporationsByMgntGrp(MgntGrpId) {

  const isValidToken = await validateToken();
  if (!isValidToken) return null;

  const token = getToken();

  let res = await fetch(`${baseApi7Url}/GetCorpsByMgntGrpWithPmsBrandSerTypes?MgntGrpId=${MgntGrpId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  return res.json();
}

export async function getUserPreferences(UserID) {

  const isValidToken = await validateToken();
  if (!isValidToken) return null;

  const token = getToken();
  let res = await fetch(`${baseApi7Url}/UserPreferences`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ UserID }),
  });
  return res.json();
}
